module.exports = __webpack_public_path__ + "static/media/search-icon.09635c13.svg";